const initialState = {
    articles : null
};

const communityReducer = (state = initialState, action) => {
    switch(action.type){
        case 'ARTICLES_LOAD_SUCCESS' : {
            return {
                ...state,
                articles : action.payload.articles.reverse()
            }
        }break;

        case 'ARTICLE_SEEN' : {
            let copy = {
                ...state
            }
            console.log(copy.articles)
            copy.articles[action.payload.index].seen = true;
            return copy;
        }break;
        default : {
            return state;
        }break;
    }
}

export default communityReducer;


// WEBPACK FOOTER //
// ./src/reducers/communityReducer.js